<template>
  <div class="form-item-view text-default text-16 py-10" :class="['form-item-view', border && 'border-t']">
    <div class="flex justify-between" :class="type !== 'text' ? 'flex-col' : ''">
      <span class="leading-30"> {{ label }} <i v-if="required" class="text-required">*</i> </span>
      <template v-if="!$slots.default">
        <span class="text-gray leading-30" v-if="type === 'text'">
          {{ value || defaultValue }}
        </span>
        <span v-if="type === 'hasBg'" class="has-bg break-all">
          {{ value || defaultValue }}
        </span>
        <div v-if="type === 'img'" class="image-view grid grid-cols-3">
          <van-image
            style="height:105px"
            v-for="(item, index) in value"
            :key="index"
            :src="item.photo_thumb_file"
            @click="handleImg(value)"
          />
        </div>
      </template>
      <slot v-else></slot>
    </div>

    <van-image-preview v-model:show="showImagePreview" closeable :images="imageList" />
  </div>
</template>
<script setup>
import { ref } from "vue";
defineProps({
  required: { default: false },
  label: { default: "" },
  value: { default: "" },
  border: { default: true },
  type: { default: "text" },
  defaultValue: { default: "-" }
});

const showImagePreview = ref(false);
const imageList = ref([]);

const handleImg = list => {
  showImagePreview.value = true;
  imageList.value = list.map(i => i.photo_thumb_file);
};
</script>
<style lang="less" scoped>
.form-item-view {
  .has-bg {
    background-color: #f5f6f7;
    color: #888888;
    font-size: 16px;
    padding: 10px;
    line-height: 20px;
    margin-top: 10px;
  }

  .image-view {
    gap: 15px;
    margin-top: 10px;
  }
}
</style>
